module.exports = __webpack_public_path__ + "static/media/sound_off_icon.f6f98daa.svg";